<template>
  <form>
    <section class="box-wrap" v-if="delivery.requests">
      <div
        class="box"
        v-for="(request, index) of delivery.requests"
        :key="`box-${index}`"
      >
        <span @click="deleteRequest(index)" class="mck icon--delete">b</span>

        <TheInput
          :dark="true"
          label="ЗАЯВКА ЗА"
          placeholder="Въведете свободен текст"
          :disabled="request._id"
          v-model="request.name"
        />

        <TheInput
          :dark="true"
          type="dropdown"
          :options="unitTypes"
          label="МЕРНА ЕДИНИЦА"
          placeholder="Изберете"
          :disabled="request._id"
          v-model="request.unit"
          @update:modelValue="setUnit(index, $event)"
        />
        <TheInput
          :dark="true"
          label="КОЛИЧЕСТВО"
          placeholder="Попълнете"
          :digitsOnly="true"
          :disabled="request._id"
          v-model="request.qty"
        />
      </div>
    </section>
    <div @click="addRequest()" class="add">
      <span class="mck">L</span>
      <p>Добавете материал за доставка</p>
    </div>

    <template>
      <section class="delivery-files">
        <h1>ЗАЯВКА ЧРЕЗ ФАЙЛ</h1>

        <section class="files-wrapper">
          <div
            class="file"
            v-for="(file, index) of delivery.files"
            :key="index"
          >
            <p>{{ file.name }}</p>
          </div>
        </section>

        <div @click="clickFileInput()" class="add">
          <span class="mck">L</span>
          <p>Добавяне на документи</p>
        </div>

        <span class="info"
          >(Качените документи могат да бъдат свалени или изтрити от менюто
          Действия > Виж документацията)</span
        >
      </section>

      <input
        type="file"
        :multiple="true"
        name="file"
        class="file-input"
        @change="handleFiles($event.target.files)"
        ref="fileInput"
      />
    </template>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
export default {
  props: ["delivery"],
  components: { TheInput },
  data() {
    return {
      unitTypes: [
        "м.",
        "м2",
        "м3",
        "бр",
        "кг",
        "тон",
        "литри",
        "м.л",
        "мсм",
        "курс",
        "ч. ч",
        "ч. д",
      ],
    };
  },
  methods: {
    deleteRequest(index) {
      this.delivery.requests.splice(index, 1);
    },
    setUnit(index, e) {
      this.$set(this.delivery.requests[index], "unit", e);
    },
    addRequest() {
      if (!this.delivery.requests) this.$set(this.delivery, "requests", []);

      this.delivery.requests.push({});
    },

    clickFileInput() {
      this.$refs["fileInput"].click();
    },
    handleFiles(files) {
      let deliveryFiles = [];
      let totalFilesSize = 0;
      let maxFilesSize = 10 * 1024 * 1024; // 10 mb

      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/plain",
      ];

      for (let file of files) {
        if (allowedTypes.indexOf(file.type) < 0) {
          this.$snotify.error(
            "Може да прикачвате само pdf, doc, docx, xls, xlsx и txt"
          );
          continue;
        }

        console.log(Number(file.size));
        totalFilesSize += Number(file.size);

        // stops adding files if the maxSize has been reached
        if (totalFilesSize > maxFilesSize) {
          this.$snotify.warning(
            "Не може да качвате файлове повече от 10 мб, изберете по-малко"
          );
          deliveryFiles = [];
          return;
        } else {
          deliveryFiles.push(file);
        }
      }

      this.$set(this.delivery, "files", deliveryFiles);
    },
  },
};
</script>

<style scoped lang="scss">
.delivery-files {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 10px 0;

  .files-wrapper {
    max-height: 70px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .file {
      align-items: center;
      background: #e9e9e9;
      border-radius: 4px;
      display: flex;
      padding: 5px;
      gap: 5px;
      justify-content: space-between;

      .mck {
        cursor: pointer;
        font-size: 16px;
      }
    }
  }

  h1 {
    font-size: 12px;
  }
  .info {
    font-size: 12px;
    opacity: 0.5;
  }
}
.file-input {
  cursor: pointer;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  width: 1px;
}
</style>
